"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlOverrideConfig = void 0;
const web_env_1 = require("@snapchat/web-env");
function getUrlOverrideConfig(experimentId) {
    if (typeof (0, web_env_1.getWindow)() === "undefined") {
        return undefined;
    }
    const queryParams = new URLSearchParams((0, web_env_1.getWindow)()?.location.search);
    const queryParam = queryParams.get(`CONFIG:${experimentId}`);
    if (queryParam && !(0, web_env_1.isProd)()) {
        const stringValue = String(queryParam).toLowerCase();
        return {
            configId: experimentId,
            value: {
                stringValue: stringValue,
                // Only used in internal usage, so dont need to handle parsing errors
                intValue: parseInt(queryParam),
                boolValue: stringValue === "true" || stringValue === "false"
                    ? JSON.parse(stringValue)
                    : undefined,
            },
        };
    }
    return undefined;
}
exports.getUrlOverrideConfig = getUrlOverrideConfig;
//# sourceMappingURL=url-override.js.map